/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { TGetBlueprintSchemaSpec, Type } from "@adapptio/lib-blueprint";
import {
	NODE_OUTPUT_NAMES,
	TAllNodesSpec,
	TBlueprintActionNodeTypes,
	TBlueprintConditionNodeOptsSchemaSpec
} from "../../blueprints";
import { IActionContext, INodeContext, INodeResult } from "../ActionManager";
import { createSuccessNodeResult } from "../helpers";

export async function conditionNodeHandler<TSpec extends Partial<TAllNodesSpec>>(
	opts: TBlueprintConditionNodeOptsSchemaSpec,
	aCtx: IActionContext<TSpec>,
	nCtx: INodeContext
): Promise<INodeResult> {
	const { condition } = opts as TGetBlueprintSchemaSpec<TBlueprintActionNodeTypes["condition"]["opts"]>;

	let outputName = NODE_OUTPUT_NAMES.ON_FALSE;
	if (condition === true) {
		outputName = NODE_OUTPUT_NAMES.ON_TRUE;
	}

	return createSuccessNodeResult(
		{
			opts,
			outputName,
			data: condition === true ? true : false,
			typeDescriptor: Type.Boolean({})
		},
		aCtx,
		nCtx
	);
}
